import React from 'react'

export const AccessDenied = () => {
  return (
    <div>Access Denied</div>
  )
}
